import { getAuth, GoogleAuthProvider, signInWithEmailAndPassword, signInWithPopup, signOut } from "firebase/auth";
import { collection, deleteDoc, doc, getDocs, limit, query, runTransaction, setDoc, updateDoc, where } from 'firebase/firestore';
import { defineStore } from 'pinia';
import { db } from './firebase';
const auth = getAuth()
const provider = new GoogleAuthProvider();
provider.addScope('https://www.googleapis.com/auth/contacts.readonly');


export const useAdminStore = defineStore({
  id: 'admin',
  state: () => ({
    userList: [],
    clotheList: [],
    currentAccount: null
  }),
  getters: {
    
  },
  actions: {
    saveUser(user) {
      this.currentAccount = user
    },
    async queryUser(filters=[]) {
      console.log('user loaded')
      try {
        const wheres = filters.filter(f => f.value).map(f => where(f.column, '==', f.value))
        if (!wheres.length) wheres.push(limit(50))
        const userRef = collection(db, 'User')
        const snapshot = await getDocs(query(userRef, ...wheres))
        const data = snapshot.docs.map(doc => ({ key: doc.id, ...doc.data() }))
        this.userList = data
        return { state: "SUCCESS" }
      } catch (error) {
        return { state: 'ERROR', message: error.message }
      }
    },
    async queryClothe(filters = []) {
      console.log('clothe loaded')
      try{
        const wheres = filters.filter(f => f.value).map(f => where(f.column, '==', f.value))
        if (!wheres.length) wheres.push(limit(50))
        const clotheRef = collection(db, 'Clothe')
        const snapshot = await getDocs(query(clotheRef, ...wheres))
        const data = snapshot.docs.map(doc => ({ key: doc.id, ...doc.data() }))
        this.clotheList = data
        return { state: "SUCCESS" }
      } catch (error) {
        return { state: 'ERROR', message: error.message }
      }
    },
    async updateData({ collectionName, data }) {
      const { key, ...otherData } = data
      try {
        const docRef = doc(db, collectionName, key)
        if (collectionName === 'User' && key !== data.email) {
          await deleteDoc(docRef)
          setDoc(doc(db, collectionName, data.email), { ...otherData, '編號': Number(data['編號']) })
        }
        else if (collectionName === 'Clothe' && key !== data['編號']) {
          await deleteDoc(docRef)
          setDoc(doc(db, collectionName, data['編號']), { ...otherData, '編號': Number(data['編號']) })
        }
        else {
          updateDoc(docRef, { ...otherData, '編號': Number(data['編號']) })
        }
        const index = this[collectionName === 'User' ? 'userList' : 'clotheList'].map(e => e.key).indexOf(key)
        this[collectionName === 'User' ? 'userList' : 'clotheList'].splice(index, 1 , { key: collectionName === 'User' ? data.email : data['編號'], ...otherData })
        return { state: 'SUCCESS' }
      } catch (error) {
        return { state: 'ERROR', message: error.message }
      }
    },
    async deleteData({ collectionName, dataKey }) {
      const docRef = doc(db, collectionName, dataKey)
      try {
        await deleteDoc(docRef)
        const index = this[collectionName === 'User' ? 'userList' : 'clotheList'].map(e => e.key).indexOf(dataKey)
        this[collectionName === 'User' ? 'userList' : 'clotheList'].splice(index, 1)
        return { state: 'SUCCESS' }
      } catch (error) {
        return { state: 'ERROR', message: error.message }
      }
    },
    async cleanCollection(collectionName) {
      const collectionRef = collection(db, collectionName)
    },
    async login({email, password}) {
      const userACredential = await signInWithEmailAndPassword(auth, email, password)
      console.log(userACredential)
      try {
        this.currentAccount = userACredential.user
        return { state: 'SUCCESS' }
      } catch (error) {
        return { state: 'ERROR', message: error.message }
      }
    },
    async loginWithGoogle() {
      const result = await signInWithPopup(auth, provider)
      try {
        // const credential = GoogleAuthProvider.credentialFromResult(result);
        // const token = credential.accessToken;
        console.log(result.user)
      } catch (error) {
        console.log(error)
      }
      

    },
    async signOut () {
      const result = signOut(auth)
      try {
        this.currentAccount = null
        return { state: 'SUCCESS' }
      } catch (error) {
        return { state: 'ERROR', message: error.message }
      }
    },
    async batchWriteToCollection(collectionName, data) {
      console.log(collectionName, data)
      let round = Math.ceil(data.length / 500)
      console.log(round)
      let promises = []
      for (let roundIndex = 0; roundIndex < round; roundIndex++) {
        promises.push(new Promise(async (res, rej) => {
          try {
            await runTransaction(db, async transaction => {
              let IdColumn = collectionName === 'User' ? 'email' : '編號'
              for (const row of data.slice(roundIndex * 500, (roundIndex + 1) * 500)) {
                console.log(row)
                if (collectionName === 'Clothe') row['編號'] = Number(row['編號'])
                console.log(row)
                let docRef = doc(db, collectionName, String(row[IdColumn]))
                transaction.set(docRef, row)
              }
            })
            res()
          } catch (error) {
            rej(error)
          }
        }))
      }

      try {
        await Promise.all(promises)
        return { state: 'SUCCESS' }
      } catch (error) {
        console.log(error)
        if (error.message === "Invalid document reference. Document references must have an even number of segments, but Clothe has 1.") return { state: 'ERROR', message: '編號欄位(資料庫識別用)不得為空值' }
        return { state: 'ERROR', message: error }
      }
    }
  }
})
